<template>
  <v-dialog full-width v-model="upgradeDialog" persistent width="570px">
    <v-card>
      <v-card-title primary-title>
        <span :class="$vuetify.breakpoint.smAndDown ? 'headline' : 'display-1'">Tenha essa funcionalidade!</span>
        <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="$emit('closeDialog')">
          <v-icon color="#444">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <iframe v-if="upgradeDialog" width="100%" height="320px" :src="link_src" allowfullscreen>
        </iframe>
          <v-flex xs12 align="center">
          <v-btn block outline @click="upgradeClick" large color="#ffc107">
            <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px"> &nbsp; Fazer Upgrade
          </v-btn>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      upgradeDialog: false,
      link_src: ''
    },
    methods: {
      upgradeClick () {
        this.$emit('closeDialog')
        this.$emit('closeNotepad')
        this.$router.push(`/upgrade`)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PUpgradeDialog.vue